import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ApiTravelMediaImportHelperService {
  status = [
    { id: 'waiting', name: 'En attente de traitement', color: 'basic' },
    { id: 'model-error', name: 'Modèle introuvable', color: 'alert' },
    { id: 'unknown-error', name: 'Erreur inconnue', color: 'error' },
    { id: 'in-progress', name: 'En traitement', color: 'basic' },
    { id: 'handled', name: 'Traité', color: 'accent' },
    { id: 'assigned', name: 'Assigné', color: 'primary' },
  ];

  getStatusName(travelMember: any) {
    const status = this.status.find((item) => item.id == travelMember?.status);
    return status?.name || 'Inconnu';
  }

  getStatusColor(travelMember: any) {
    const status = this.status.find((item) => item.id == travelMember?.status);
    return status?.color || 'accent';
  }
}
